import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'giftApplied',
  pure: false,
})
export class GiftAppliedPipe implements PipeTransform {
  transform(giftCards: { cardnumber?: string }[] | null, rawNumber?: string): boolean {
    if (!rawNumber) {
      return false;
    }
    const num = rawNumber.replace(/-/g, '');
    return !!giftCards?.some((c) => c.cardnumber === num);
  }
}
